import script from "./LawFirmView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LawFirmView.vue?vue&type=script&lang=ts&setup=true"

import "./LawFirmView.vue?vue&type=style&index=0&id=1ece4377&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ece4377"]])

export default __exports__